import team_member_EdW from '../assets/images/team_members/team_member_EdW.jpg';
import team_member_EdW_Hover from '../assets/images/team_members/team_member_EW_Hover.jpg';
import team_member_AndrewK from '../assets/images/team_members/team_member_AndrewK.jpg';
import team_member_AndrewK_Hover from '../assets/images/team_members/team_member_AK_Hover.jpg';
import team_member_GregL from '../assets/images/team_members/team_member_GregL.jpg';
import team_member_GregL_Hover from '../assets/images/team_members/team_member_GL_Hover.jpg';
import team_member_IanB from '../assets/images/team_members/team_member_IanB.jpg';
import team_member_IanB_Hover from '../assets/images/team_members/team_member_IB_Hover.jpg';
import team_member_JeffN from '../assets/images/team_members/team_member_JeffN.jpg';
import team_member_JeffN_Hover from '../assets/images/team_members/team_member_JN_Hover.jpg';
import team_member_KevinD from '../assets/images/team_members/team_member_KevinD.jpg';
import team_member_KevinD_Hover from '../assets/images/team_members/team_member_KD_Hover.jpg';
import team_member_EricD from '../assets/images/team_members/team_member_EricD.jpg';
import team_member_EricD_Hover from '../assets/images/team_members/team_member_ED_Hover.jpg';
import team_member_QuinnH from '../assets/images/team_members/team_member_QuinnH.jpg';
import team_member_QuinnH_Hover from '../assets/images/team_members/team_member_QH_Hover.jpg';
import team_member_NicholasL from '../assets/images/team_members/team_member_NicholasL.jpg';
import team_member_NicholasL_Hover from '../assets/images/team_members/team_member_NL_Hover.jpg';
import team_member_RebeccaJ from '../assets/images/team_members/team_member_RebeccaJ.jpg';
import team_member_RebeccaJ_Hover from '../assets/images/team_members/team_member_RJ_Hover.jpg';
import team_member_JoshuaV from '../assets/images/team_members/team_member_JoshuaV.jpg';
import team_member_JoshuaV_Hover from '../assets/images/team_members/team_member_JV_Hover.jpg';
import team_member_JennakaU from '../assets/images/team_members/team_member_JennakaU.jpg';
import team_member_JennakaU_Hover from '../assets/images/team_members/team_member_JU_Hover.jpg';
import team_member_RandyF from '../assets/images/team_members/team_member_RandyF.jpg';
import team_member_RandyF_Hover from '../assets/images/team_members/team_member_RF_Hover.jpg';
import team_member_AndrewP from '../assets/images/team_members/team_member_AndrewP.jpg';
import team_member_AndrewP_Hover from '../assets/images/team_members/team_member_AP_Hover.jpg';
import team_member_NickV from '../assets/images/team_members/team_member_NickV.jpg';
import team_member_NickV_Hover from '../assets/images/team_members/team_member_NV_Hover.jpg';
import team_member_LeoB from '../assets/images/team_members/team_member_LeoB.jpg';
import team_member_LeoB_Hover from '../assets/images/team_members/team_member_LB_Hover.jpg';
import team_member_SimonL from '../assets/images/team_members/team_member_SimonL.jpg';
import team_member_SimonL_Hover from '../assets/images/team_members/team_member_SL_Hover.jpg';
import team_member_BrandonC from '../assets/images/team_members/team_member_BrandonC.jpg';
import team_member_BrandonC_Hover from '../assets/images/team_members/team_member_BC_Hover.jpg';
import team_member_JacobbR from '../assets/images/team_members/team_member_JacobbR.jpg';
import team_member_JacobbR_Hover from '../assets/images/team_members/team_member_JR_Hover.jpg';
import team_member_AndreS from '../assets/images/team_members/team_member_AndreS.jpg';
import team_member_AndreS_Hover from '../assets/images/team_members/team_member_AS_Hover.jpg';
import team_member_AvalonA from '../assets/images/team_members/team_member_AvalonA.jpg';
import team_member_AvalonA_Hover from '../assets/images/team_members/team_member_AA_Hover.jpg';
import team_member_RachelL from '../assets/images/team_members/team_member_RachelL.jpg';
import team_member_RachelL_Hover from '../assets/images/team_members/team_member_RL_Hover.jpg';
import team_member_MatthewS from '../assets/images/team_members/team_member_MatthewS.jpg';
import team_member_MatthewS_Hover from '../assets/images/team_members/team_member_MS_Hover.jpg';

export const AboutTeamData = [
    {
        name: 'Ed Wisniewski',
        designation: 'CTO',
        image: { src: team_member_EdW, alt: 'Ed Wisniewski' },
        hover: { src: team_member_EdW_Hover, alt: '' },
        social: []
    },
    {
        name: 'Andrew Kostuik',
        designation: 'Studio Director',
        image: { src: team_member_AndrewK, alt: 'Andrew Kostuik' },
        hover: { src: team_member_AndrewK_Hover, alt: '' },
        social: []
    },
    {
        name: 'Greg Lajeunesse',
        designation: 'IT Director',
        image: { src: team_member_GregL, alt: 'Greg Lajeunesse' },
        hover: { src: team_member_GregL_Hover, alt: '' },
        social: []
    },
    {
        name: 'Rachel Labelle',
        designation: 'Producer',
        image: { src: team_member_RachelL, alt: 'Rachel Labelle' },
        hover: { src: team_member_RachelL_Hover, alt: '' },
        social: []
    },
    {
        name: 'Ian Busch, P.Eng.',
        designation: 'Staff Engineer',
        image: { src: team_member_IanB, alt: 'Ian Busch' },
        hover: { src: team_member_IanB_Hover, alt: '' },
        social: []
    },
    {
        name: 'Jeff Nicholls',
        designation: 'Systems Developer',
        image: { src: team_member_JeffN, alt: 'Jeff Nicholls' },
        hover: { src: team_member_JeffN_Hover, alt: '' },
        social: []
    },
    {
        name: 'Kevin Dallaire',
        designation: 'Lead Software Developer',
        image: { src: team_member_KevinD, alt: 'Kevin Dallaire' },
        hover: { src: team_member_KevinD_Hover, alt: '' },
        social: []
    },
    {
        name: 'Eric Daoust',
        designation: 'Software Developer',
        image: { src: team_member_EricD, alt: 'Eric Daoust' },
        hover: { src: team_member_EricD_Hover, alt: '' },
        social: []
    },
    {
        name: 'Randy Fortier',
        designation: 'Software Developer',
        image: { src: team_member_RandyF, alt: 'Randy Fortier' },
        hover: { src: team_member_RandyF_Hover, alt: '' },
        social: []
    },
    {
        name: 'Joshua Vaters',
        designation: 'Senior Technical Artist',
        image: { src: team_member_JoshuaV, alt: 'Joshua Vaters' },
        hover: { src: team_member_JoshuaV_Hover, alt: '' },
        social: []
    },
    {
        name: 'Jennaka Urisk',
        designation: 'UI/UX Lead',
        image: { src: team_member_JennakaU, alt: 'Jennaka Urisk' },
        hover: { src: team_member_JennakaU_Hover, alt: '' },
        social: []
    },
    {
        name: 'Nick Vildis',
        designation: 'Senior Generalist',
        image: { src: team_member_NickV, alt: 'Nick Vildis' },
        hover: { src: team_member_NickV_Hover, alt: '' },
        social: []
    },
    {
        name: 'Rebecca Joly',
        designation: 'Senior XR Developer',
        image: { src: team_member_RebeccaJ, alt: 'Rebecca Joly' },
        hover: { src: team_member_RebeccaJ_Hover, alt: '' },
        social: []
    },
    {
        name: 'Quinn Henschel',
        designation: 'XR Developer',
        image: { src: team_member_QuinnH, alt: 'Quinn Henschel' },
        hover: { src: team_member_QuinnH_Hover, alt: '' },
        social: []
    },
    {
        name: 'Nicholas Lamonica',
        designation: 'XR Developer',
        image: { src: team_member_NicholasL, alt: 'Nicholas Lamonica' },
        hover: { src: team_member_NicholasL_Hover, alt: '' },
        social: []
    },
    {
        name: 'Andrew Persechino',
        designation: 'XR Developer',
        image: { src: team_member_AndrewP, alt: 'Andrew Persechino' },
        hover: { src: team_member_AndrewP_Hover, alt: '' },
        social: []
    },
    {
        name: 'Léo Buono',
        designation: 'XR Developer',
        image: { src: team_member_LeoB, alt: 'Léo Buono' },
        hover: { src: team_member_LeoB_Hover, alt: '' },
        social: []
    },
    {
        name: 'Simon Lopez',
        designation: 'XR Developer',
        image: { src: team_member_SimonL, alt: 'Simon Lopez' },
        hover: { src: team_member_SimonL_Hover, alt: '' },
        social: []
    },
    {
        name: 'Brandon Cotesta',
        designation: 'XR Developer',
        image: { src: team_member_BrandonC, alt: 'Brandon Cotesta' },
        hover: { src: team_member_BrandonC_Hover, alt: '' },
        social: []
    },
    {
        name: 'Jacobb Rozon',
        designation: 'XR Developer',
        image: { src: team_member_JacobbR, alt: 'Jacobb Rozon' },
        hover: { src: team_member_JacobbR_Hover, alt: '' },
        social: []
    },
    {
        name: 'Andre Sokolow',
        designation: 'Lead 3D Artist',
        image: { src: team_member_AndreS, alt: 'Andre Sokolow' },
        hover: { src: team_member_AndreS_Hover, alt: '' },
        social: []
    },
    {
        name: 'Avalon Appleton',
        designation: '3D Artist',
        image: { src: team_member_AvalonA, alt: 'Avalon Appleton' },
        hover: { src: team_member_AvalonA_Hover, alt: '' },
        social: []
    },
    {
        name: 'Matthew Silvestri',
        designation: '3D Artist',
        image: { src: team_member_MatthewS, alt: 'Matthew Silvestri' },
        hover: { src: team_member_MatthewS_Hover, alt: '' },
        social: []
    }
];
